module.exports = __webpack_public_path__ + "static/media/advantages_5.974a42d1.svg";